import checkAndUpdatePersistedAddins from './services/checkAndUpdatePersistedAddins';
import checkAndUpdatePinnedAddins from './services/checkAndUpdatePinnedAddins';
import {
    checkAndUpdateClientTypeOptInState,
    cleanupLegacyAppcache,
    cleanupOptInCallout,
} from 'owa-optin';

export default function initializeMailOptinService() {
    // Cleanup OptIn callout
    // NOTE: checkAndUpdateClientTypeOptInState cleans up the cookie, so it needs to happen after
    // all actions that check the cookie
    cleanupOptInCallout();

    checkAndUpdatePinnedAddins();
    checkAndUpdatePersistedAddins();

    // Check and update the opt-in state if user is navigating from legacy owa
    checkAndUpdateClientTypeOptInState(window);

    // Cleanup legacy caches
    cleanupLegacyAppcache(window);
}
